import React, { lazy } from 'react';

// 功能页面
const IatToChatGpt = lazy(() => import('@/pages/func/IatToChatGpt'));
// 怡安绿通介绍
const GreenChannelService = lazy(() => import('@/pages/static/GreenChannelService'));
// 广告页面
const Advertising = lazy(() => import('@/pages/static/Advertising'));

const otherRoutes = [
  { path: '/client/advertising/:id', component: <Advertising />, needInterceptor: false },
  // 录音后解析成文字，然后转chatGpt输入结果
  { path: '/iat-to-gpt', component: <IatToChatGpt />, needInterceptor: true },
  // 新增怡安绿通介绍界面---纯静态
  { path: '/static/green-channel', component: <GreenChannelService />, needInterceptor: false },
]

export default otherRoutes;
